import { datadogLogs } from '@datadog/browser-logs';

export const getThirdPartyEnvironmentId = () => {
  const h = document.location.host;

  if (h === 'insights.hotjar.com') {
    return 'live';
  }
  const result = h.match(/^insights-(.+)\.review\.eks\.hotjar\.com$/);
  if (result) {
    return result[2];
  }
  if (h === 'insights-integration.live.eks.hotjar.com') {
    return 'integration';
  }

  return 'dev';
};

const environmentId = getThirdPartyEnvironmentId();

export function initDataDogLogs({ serviceName, version }) {
  datadogLogs.init({
    clientToken: 'pub980ac3345f76d59f07e84bd74b4733c4',
    site: 'datadoghq.eu',
    service: serviceName || 'engage-legacy-frontend',
    version,
    env: environmentId,
    forwardErrorsToLogs: false, // Errors are tracked via Sentry
    sessionSampleRate: 100,
    forwardReports: ['deprecation', 'csp_violation'],
    telemetrySampleRate: 0,
    useSecureSessionCookie: true
  });
}

/**
 * @typedef {Function} Log
 * @param {string} msg - The message to log
 * @param {Object} ctx - Context for the log
 */

/**
 * @typedef {Object} DatadogLogger
 * @property {Log} error
 * @property {Log} warn
 * @property {Log} info
 * @property {Log} log
 * @property {Log} debug
 */

/**
 * @summary Create a logger for Datadog
 * @param  {string} name Name of the logger
 * @return {DatadogLogger}
 * @example const logger = createLogger('room-events');
 */
export const createLogger = (name) => {
  const context = window.datadogRum?.getInternalContext();
  const logger = window.datadogLogs?.createLogger(name, { team: 'Engage', ...context }) ?? console;

  const wrap = (log) => (msg, ctx) => {
    const appContext = window.datadogRum?.getGlobalContext();
    log(msg, {
      ...ctx,
      ...appContext
    });
  };

  return {
    error: wrap(logger.error),
    warn: wrap(logger.warn),
    info: wrap(logger.info),
    log: wrap(logger.log),
    debug: wrap(logger.debug)
  };
};
